<script setup lang="ts">
import type { ChartExportFileType } from '@/views/calculations/utils/resultChartExportUtils'

defineProps<{
  fileTypes: { value: ChartExportFileType; title: string }[]
}>()
const dialogOpen = defineModel<boolean>({ required: true })

const emit = defineEmits<{
  download: [fileType: ChartExportFileType]
}>()
</script>

<template>
  <v-dialog v-model="dialogOpen" max-width="300">
    <v-card class="export-panel">
      <div class="export-panel-header">
        <div class="d-flex align-center">
          <v-icon color="cyan-darken-2" size="18" class="mr-3">mdi-file-export-outline</v-icon>
          <span class="font-weight-medium">Export as...</span>
        </div>
        <v-icon size="18" @click="dialogOpen = false">mdi-chevron-up</v-icon>
      </div>
      <v-divider />
      <v-list density="compact" class="export-panel-list">
        <v-list-item
          v-for="fileType in fileTypes"
          :key="fileType.value"
          class="export-panel-item"
          @click="emit('download', fileType.value)"
        >
          <template v-slot:prepend>
            <v-icon color="cyan-darken-2" size="18">mdi-file-download-outline</v-icon>
          </template>
          <v-list-item-title>{{ fileType.title }}</v-list-item-title>
          <template v-slot:append>
            <span class="export-action">Export</span>
          </template>
        </v-list-item>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.export-panel {
  border-radius: 4px;
  min-width: 300px;
  overflow: hidden;
}

.export-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 0 16px;
}

.export-panel-list {
  padding: 4px 0;
}

.export-panel-item {
  min-height: 44px;
  padding: 0 16px;
}

.export-action {
  color: #1697a7;
  font-weight: 700;
}
</style>
